"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateReplaceMap = exports.updateShadowText = void 0;

var _diff = require("diff");

var CHANGEABLE_PLACEHOLDER_LIST = [];

var updateShadowText = function updateShadowText(sender, text, shadowText) {
  var firstName = sender.first_name,
      lastName = sender.last_name,
      fullName = sender.full_name,
      _sender$company = sender.company,
      company = _sender$company === void 0 ? '' : _sender$company;
  var changeableSenderDataList = [firstName, lastName, fullName, company];
  var diffList = (0, _diff.diffWords)(shadowText, text);
  var i = 0;
  var updatedShadowText = '';

  var _loop = function _loop() {
    var _diffList$i = diffList[i],
        value = _diffList$i.value,
        removed = _diffList$i.removed;
    var next = diffList[i + 1] ? diffList[i + 1].value : '';
    var isPlaceholder = CHANGEABLE_PLACEHOLDER_LIST.includes(value.trim());
    var isNextChangeable = changeableSenderDataList.includes(next.trim());
    var shouldReplaceNext = isPlaceholder && isNextChangeable;
    i += shouldReplaceNext ? 2 : 1;

    if (!removed || shouldReplaceNext) {
      updatedShadowText += value;
    } else if (isPlaceholder && !isNextChangeable) {
      var isNextLast = !diffList[i + 2];
      var changeableDataContainedInNext = changeableSenderDataList.find(function (data) {
        return next.includes(data);
      });
      var shouldModifyNext = isNextLast && changeableDataContainedInNext;

      if (shouldModifyNext) {
        updatedShadowText += next.replace(changeableDataContainedInNext, value);
        i += 1;
      }
    }
  };

  while (i < diffList.length) {
    _loop();
  }

  return updatedShadowText; // a shadow copy of text input with placeholders in place
}; // eslint-disable-next-line require-jsdoc


exports.updateShadowText = updateShadowText;

var generateReplaceMap = function generateReplaceMap(sender, recipient, giftLink, giftProduct) {
  var replaceMap = {};
  replaceMap['\\[my-first-name\\]'] = sender.first_name;
  replaceMap['\\[my-last-name\\]'] = sender.last_name;
  replaceMap['\\[my-full-name\\]'] = sender.full_name;

  if (sender.company) {
    replaceMap['\\[company\\]'] = sender.company;
  }

  if (recipient) {
    replaceMap['\\[first-name\\]'] = recipient.first_name;
    replaceMap['\\[last-name\\]'] = recipient.last_name;
    replaceMap['\\[full-name\\]'] = recipient.full_name;
  }

  if (recipient.company) {
    replaceMap['\\[recipient-company\\]'] = recipient.company;
  }

  if (giftLink) {
    replaceMap['\\[gl\\]'] = giftLink;
  }

  if (giftProduct) {
    replaceMap['\\[gift-name\\]'] = giftProduct.name;
    replaceMap['\\[product-brand\\]'] = giftProduct.vendor_name;
  }

  return replaceMap;
};

exports.generateReplaceMap = generateReplaceMap;